import { render, staticRenderFns } from "./package_history.vue?vue&type=template&id=7395fd91&scoped=true&"
import script from "./package_history.vue?vue&type=script&lang=js&"
export * from "./package_history.vue?vue&type=script&lang=js&"
import style0 from "./package_history.vue?vue&type=style&index=0&id=7395fd91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7395fd91",
  null
  
)

export default component.exports